module.exports = __webpack_public_path__ + "img/note-slide.58432bd9.gif";